<template>
    <div class="container zx-fill-ticket-info">

        <div class="swipe-header">
            <div class="image-box">
                <van-swipe :autoplay="3000" class="swipe-box">
                    <van-swipe-item v-for="(image, index) in swipeArray" :key="index">
                        <van-image 
                            class="swipe-itme"
                            lazy-load
                            :src="image"
                        />
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>

        <div class="body g-big-tree-bg">
            
            <!-- 预约信息 -->
            <ul class="body-rander-item ">
                <li class="row-box info-row info-title ">
                    <div class="inner-row f-s-b">
                        <div class="info-left">
                            <i class="iconhebei iconxiangqing theme-color-font icon-size"></i>
                            <span>{{getDetailInfo.activityName}}</span>
                        </div>
                        <div class="info-right f-c ellipsis">
                            <span>剩余名额:</span>
                            <span class="g-yellow-color count g-b-500">{{getDetailInfo.canEntryNum}}</span>
                        </div>
                    </div>
                </li>

                <li class="row-box info-row f-c">
                    <i class="iconhebei iconshizhong g-yellow-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '活', '动' ,'时', '间' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: {{getDetailInfo.dateStr}}</span>
                </li>
                <li class="row-box info-row f-c">
                    <i class="iconhebei iconwode1 g-violet-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '报', '名', '人', '数' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: {{getDetailInfo.peopleNumber}}人</span>
                </li>
                <li class="row-box info-row f-c">
                    <i class="iconhebei iconnianling g-green-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '报', '名', '条', '件' ]" :key="index">{{item}}</span>
                    </span>
                    <!-- <span class="right-txt">: {{getDetailInfo.requirements}}</span> -->
                    <span class="right-txt">: {{getDetailInfo.requirementsStr}}</span>
                </li>

                <li class="row-box info-row f-c">
                    <i class="iconhebei iconprice g-yellow-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '地', '址' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: {{getDetailInfo.activityAddr}}</span>
                </li>

                <li class="row-box info-row f-c">
                    <!-- <i class="iconhebei iconprice g-violet-color"></i> -->
                    <i class="iconhebei iconjifen g-violet-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '积', '分' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: {{getDetailInfo.scoreNum || 0}}分</span>
                </li>

                <!-- <li class="row-box info-row f-c">
                    <i class="iconhebei iconrenshu g-violet-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '报', '名', '限', '制' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: 1大1小</span>
                </li> -->

                <!-- <li class="row-box info-row f-c">
                    <i class="iconhebei iconprice g-yellow-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '费', '用' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: 免费</span>
                </li> -->

            </ul>

            <ul class="body-rander-item"></ul>

            <ul class="body-container ">
                <li class="title">
                    <i class="iconhebei iconxiangqing theme-color-font"></i>
                    <span class="txt g-b-500">活动介绍</span>
                </li>
                <li class="item" v-if="getDetailInfo.content">
                    <div v-html="getDetailInfo.content"></div>
                    <!-- 科学小实验活动聿活动名称:给小动物送食物(摩擦起电)蚁材料准备:芆袅1、各种可以进行摩擦的物品螃2、将各种用海绵和胡萝卜、竹叶形状的纸屑放在...             -->
                </li>
                <li class="item" v-else>
                    暂无活动介绍
                </li>

            </ul>
        </div>

        <div class="foot f-c" :class="flag? '':'gray-color'">
            <van-button class="btn f-c" block type="info" v-touch:tap="routerPage">
                {{btnTxt}}
            </van-button>
        </div>

    </div>
</template>

<script>
    import util from '@util';
    import { 
        Button,
        Swipe, 
        SwipeItem, 
    } from 'vant';
    export default {
        data() {
            return {
                swipeArray: [
                    require('@image/home/342.png'),
                ],
                flag: false,
                btnTxt: '我要报名',
            }
        },
        created() {
        },
        methods: {
            routerPage(){
                if(this.getDetailInfo.entryStatus === 1 && this.flag){
                    this.$router.push({ name: 'registrationDetails', query: { activityId: this.getDetailInfo.id, volunteerId: this.getUserInfo.volunteerId } })
                }else if(this.flag){
                    this.$router.push({ name: 'fillVolunteerInfo' })
                }
                // return ()=> this.$router.push({ name })
            },
        },  
        computed: {
            getDetailInfo(){
                // 活动状态（1-未开始，2-报名中，3-已结束；code：activity_status）	
                var info = this.$store.state.tempTransmitParams || {};
                if(info.activityImgUrl){
                    this.swipeArray = String(info.activityImgUrl).split(',')
                }
                if(this.getUserInfo.isVolunteer === 1){
                    if(info.entryStatus === 1){
                            // 用户已经报名状态（0-未报名，1-已报名，2-已取消）	
                            this.btnTxt = '查看我的报名';
                            this.flag = true;
                        }else if(info.activityStaTime){
                            if(info.canEntryNum > 0 && info.activityStatus === 2){
                                this.flag = true;
                            }else if(info.canEntryNum <= 0){
                                this.btnTxt = '活动人员已满';
                            }else if(info.activityStatus === 1){
                                this.btnTxt = '活动暂未开始';
                            }else if(info.activityStatus === 3){
                                this.btnTxt = '活动已结束';
                            }
                            info.dateStr = `${util.formatTime(new Date(info.activityStaTime), "时分秒")} - ${util.formatTime(new Date(info.activityEndTime), "时分秒")}`
                        }
                }else{
                    this.btnTxt = '申请成为志愿者方可报名此活动';
                }
                if(info.requirementsStr === undefined){
                    info.requirementsStr = info.requirements.replace(/,/g, " ");
                }
                return info;
            },
            getUserInfo(){
                let info = this.$store.state.userInfo.info || {};
                return info;
            },
        },    
        components:{
            [Button.name]: Button,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        // height: ~"calc(100% - 50px)" !important;
        // padding-bottom: 50px;
        .swipe-header{
            overflow: hidden;
            box-sizing: border-box;
            .swipe-itme{
                width: 100%;
                height: 100%;
            }
            .image-box{
                height: 185px;
                .swipe-box{
                    height: 100%;
                }
            }
            .header-line{
                height:47px;
                background:linear-gradient(270deg,rgba(32,107,148,1) 0%,rgba(14,57,91,1) 100%);
            }
        }

        .body{
            margin-bottom: 10px;
            padding: 7px;
            .body-rander-item{
                background-color: #ffffff;
                overflow: hidden;
                border-radius:5px;
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                margin-bottom: 7px;
                .row-box{
                    position: relative;
                    box-sizing: border-box;
                    height: 50px;
                    padding: 0 12px;
                    background-color: #ffffff;
                    &:last-child{
                        .item-row{
                            border: 0;
                        }
                    }
                    .item-row{
                        border-bottom: .5px solid #CBCBCB;
                        height: 100%;
                        background-color: transparent;
                        font-size: 14px;
                    }
                    .right-control{
                        color: #9599A2;
                        position: absolute;
                        top: 50%;
                        overflow: hidden;
                        transform: translateY(-50%);
                        left: 90px;
                        right: 12px;
                        .icon-size{
                            &::before{
                                font-weight: 500;
                            }
                        }
                    }
                    .number-control{
                        justify-content: flex-start;
                        .number-box{
                            margin: 0 10px;
                            display: inline-flex;
                            vertical-align: top;
                            width:65px;
                            height:22px;
                            box-sizing: border-box;
                            border:1px solid rgba(212,212,212,1);
                        }
                        .number-icon-size{
                            &::before{
                                font-size: 20px;
                                font-weight: 500;
                            }
                        }
                    }
                }
                .info-row{
                    padding-top: 10px;
                    padding-bottom: 10px;
                    align-items: baseline;
                    height: auto;
                    justify-content: flex-start;
                    font-size: 12px;
                    color: #979899;
                    .left-txt{
                        margin-left: 12px;
                        width: 80px;
                        text-align-last: justify;
                        color: #61666C;
                        font-weight: 500;
                    }
                    .right-txt{
                        width: ~"calc(100% - 85px)";
                    }
                }
                .info-title{
                    padding-left: 0;
                    padding-right: 0;
                    margin: 0 12px;
                    border-bottom: .5px solid #CCCCCC;

                    align-items: baseline;
                    justify-content: space-between;
                    .inner-row{
                        align-items: baseline;
                    }
                    .info-left{
                        max-width: ~"calc(100% - 120px)";
                        font-size:16px;
                        font-weight:500;
                        color:rgba(67,68,70,1);
                        .icon-size{
                            margin-right: 12px;
                        }
                    }
                    .info-right{
                        display: block;
                        max-width: 130px;
                        color: #666666;
                        .count{
                            font-size: 17px;
                            margin-left: 3px;
                        }
                    }
                }
            }
            .body-container{
                position: relative;
                border-radius:5px;
                overflow: hidden;
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                background-size: 118px 142px;
                background-repeat: no-repeat;
                background-position: right 70%;
                background-image: url('../../lib/image/home/567.png');
                background-color:rgba(255,255,255,1);
                box-sizing: border-box;
                width: 100%;
                padding: 14px 12px;
                font-size: 12px;
                color: #565656;
                height: auto;
                &{
                    .item:last-child{
                        margin: 0;
                    }
                }
                .title{
                    color: #434446;
                    font-size: 15px;
                    margin-bottom: 14px;
                    .txt{
                        margin-left: 12px;
                    }
                }
                .small-title{
                    font-size: 14px;
                    color: #565656;
                }
                .body-iamge{
                    width: 100%;
                    margin: 10px 0;
                }
                .item{
                    color: #666666;
                    margin-bottom: 10px;
                }
                .time{
                    padding-left: 9px;
                    letter-spacing: 1px;
                }
            }
            .contacts-title-box{
                padding-left: 12px;
                height: 50px;
                font-size: 14px;
                color: #555555;
                // justify-content: flex-start;
                .icon-size{
                    margin-right: 5px;
                    &::before{  
                        // font-size: 22px;
                    }
                }
                .look-narrators{
                    border: 0;
                    padding: 3px 6px;
                    font-size: 15px;
                    color:rgba(255,255,255,1);
                    background:rgba(92,162,253,1);
                    border-radius:3px;
                }
            }
        }

        .foot{
            background-color: #f0f1f4;
            // position: fixed;
            // bottom: 0;
            // left: 0;
            // right: 0;
            height: 50px;
            .btn{
                border: 0;
                font-size: 15px;
                color:rgba(255,255,255,1);
                width:332px;
                height:50px;
                background:rgba(92,162,253,1);
                border-radius:12px;
            }
        }

        .language-box{
            box-sizing: border-box;
            padding: 50px;
            flex-direction: column;
            .language{
                width: 100%;
            }
            .language-row{
                width: 100%;
                height: 40px;
            }
        }
    }
</style>